import React, { useState } from 'react';
import { Avatar, Card, CardContent, CardHeader, Checkbox, Dialog, DialogTitle, FormControlLabel, IconButton, List, ListItem, ListItemAvatar, ListItemText, Typography } from "@mui/material";
// import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import { Facebook, Google, Twitter } from "@mui/icons-material";
import Div from "@jumbo/shared/Div";
import { alpha } from "@mui/material/styles";
import { ASSET_IMAGES } from "../../utils/constants/paths";
import { getAssetPath } from "../../utils/appHelpers";
import * as yup from "yup";
import { Form, Formik } from "formik";
import JumboTextField from "@jumbo/components/JumboFormik/JumboTextField";
import LoadingButton from "@mui/lab/LoadingButton";
import authServices from "../../services/auth-services";
import { Link, useNavigate } from "react-router-dom";
import useJumboAuth from "@jumbo/hooks/useJumboAuth";
import { storeToken } from '@jumbo/components/JumboAuthProvider/authHelpers';
import { setAuthToken } from 'app/services/auth/jwtAuth';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import { blue } from '@mui/material/colors';
import JumboAppContext from '@jumbo/components/JumboApp/JumboAppContext';
import Logo from 'app/shared/Logo';
import { useEffect } from 'react';
import useSwalWrapper from '@jumbo/vendors/sweetalert2/hooks';
const validationSchema = yup.object({
    username: yup
        .string('Enter your username')
        .required('Username /email is required'),
    password: yup
        .string('Enter your password')
        .required('Password is required'),
});

const Login = () => {
    // const {setAuthToken} = useJumboAuth();
    // console.log(setAuthToken);
    const [userData, setUserData] = useState({})
    const [openDialoge, setOpenDialoge] = useState(false);
    const [loading, setloading] = useState(false);
    const navigate = useNavigate();
    const jumboco = useJumboAuth()
    const swal = useSwalWrapper()
    const onSignIn = (username, password) => {
        setloading(true)
        authServices.signIn({ username, password })
            .then((data) => {
                // console.log(data);
                if (data.status =='success') {
                    // console.log(data?.branch?.length);
                    if(data?.branch?.length == 1){
                        authServices.signIn({ token:data?.user?.token,branchCode:data?.branch[0].FL_BRANCH_CODE,COID:data?.branch[0]?.FL_COMPANY_CODE }).then(async resData=>{
                            setAuthToken({...data?.user,branches:data?.branch,currentBranch:data.branch[0],token:resData.token});
                            jumboco.setAuthToken(JSON.stringify({...data?.user,branches:data?.branch,currentBranch:data.branch[0],token:resData.token}))
                            jumboco.setAuthOptions({ type: "stop-loading" });
                            navigate("/dashboard");
                        });
                        // branchSelctHandler(data.branch[0])
                    } else{
                        setUserData(data)
                        setOpenDialoge(true)
                    }
                } else{
                    swal.fire({
                        icon:'error',
                        text:data.message,
                      })  
                }
                // setAuthToken(data.user);
                // navigate("/dashboard");
            }).catch((e) => {
                console.log(e);
                swal.fire({
                    icon:'error',
                    text:e,
                  })  
            }).finally(()=>{
                setloading(false)
            });
    };
    const branchSelctHandler = (branch) => {
        // console.log(branch);
        jumboco.setAuthOptions({ type: "start-loading" });
        authServices.signIn({ token:userData.user.token,branchCode:branch.FL_BRANCH_CODE,COID:branch?.FL_COMPANY_CODE }).then(async resData=>{
            // setUserData({...userData.user,token:resData.token})
            setAuthToken({...userData.user,branches:userData.branch,currentBranch:branch,token:resData.token});
            jumboco.setAuthToken(JSON.stringify({...userData.user,branches:userData.branch,currentBranch:branch,token:resData.token}))
            jumboco.setAuthOptions({ type: "stop-loading" });
            navigate("/dashboard");
            // console.log(userData);  
        });
        // console.log(jumboco);
    }
    // useEffect(()=>{
    //     console.log(userData);
    // },[userData])
    return (<>
        <Div sx={{
            width: 500,
            maxWidth: '100%',
            margin: 'auto',
            p: 4
        }}>
            {/* <Typography variant='h2' textAlign={'center'}>Login</Typography> */}
            <Card
                sx={{
                    display: 'flex',
                    minWidth: 0,
                    flexDirection: { xs: 'column', md: 'row' }
                }}
            >
                {/* <CardContent
                    sx={{
                        flex: '0 1 300px',
                        position: 'relative',
                        background: `#0267a0 url(${getAssetPath(`${ASSET_IMAGES}/widgets/keith-luke.jpg`, "640x428")}) no-repeat center`,
                        backgroundSize: 'cover',

                        '&::after': {
                            display: 'inline-block',
                            position: 'absolute',
                            content: `''`,
                            inset: 0,
                            backgroundColor: alpha('#0267a0', .65)
                        }
                    }}
                >
                    <Div
                        sx={{
                            display: 'flex',
                            minWidth: 0,
                            flex: 1,
                            flexDirection: 'column',
                            color: 'common.white',
                            position: 'relative',
                            zIndex: 1,
                            height: '100%'
                        }}
                    >
                        <Div sx={{mb: 2}}>
                            <Typography variant={"h3"} color={"inherit"} fontWeight={500} mb={3}>Sign In</Typography>
                            <Typography variant={"body1"} mb={2}>
                                By signing in, you can avail full features of the Jumbo.
                            </Typography>
                        </Div>

                        <Div sx={{mt: 'auto'}}>
                            <Link href="#" underline="none" sx={{display: 'inline-flex'}}>
                                <img src={`${ASSET_IMAGES}/logo-white.png`} alt="Jumbo React"/>
                            </Link>
                        </Div>
                    </Div>
                </CardContent> */}
                <CardContent sx={{ flex: 1, p: 3 }}
                >
                    <div style={{display: 'block',margin: '0 auto',textAlign: 'center',maxWidth: '300px'}}><Logo /></div>
                    <Formik
                        validateOnChange={true}
                        initialValues={{
                            username: '',
                            password: '',
                        }}
                        validationSchema={validationSchema}
                        onSubmit={async (data, { setSubmitting }) => {
                            setSubmitting(true);
                            await onSignIn(data.username, data.password);
                            setSubmitting(false);
                        }}
                    >
                        {({ isSubmitting }) => (
                            <Form style={{ textAlign: 'left' }} noValidate autoComplete='off'>
                                <Div sx={{ mt: 5, mb: 3 }}>
                                    <JumboTextField
                                        fullWidth
                                        name="username"
                                        label="username / email"
                                    />
                                </Div>
                                <Div sx={{ mt: 1, mb: 2 }}>
                                    <JumboTextField
                                        fullWidth
                                        name="password"
                                        label="Password"
                                        type="password"
                                    />
                                </Div>
                                <Div sx={{ pb: 3,display: 'flex',justifyContent: 'space-between' }}>
                                    {/* <FormControlLabel control={<Checkbox/>} label="Terms "/> */}
                                    <Link to={'/user-register'}>New To Register</Link>
                                    <Link>Forgot password</Link>
                                </Div>
                                <LoadingButton
                                    fullWidth
                                    type="submit"
                                    variant="contained"
                                    size="large"
                                    sx={{ mb: 3 }}
                                    loading={loading}
                                >Sign In</LoadingButton>
                            </Form>
                        )}
                    </Formik>
                </CardContent>
            </Card>
        </Div>
        <Dialog onClose={() => setOpenDialoge(!openDialoge)} open={openDialoge}>
            <DialogTitle>Select Branch account</DialogTitle>
            <List sx={{ pt: 0, minWidth: 400 }}>
                {userData.branch && userData.branch.map((branch) => (
                    <ListItem button onClick={() => branchSelctHandler(branch)} key={branch.FL_BRANCH_CODE}>
                        <ListItemAvatar>
                            <Avatar
                                sx={{ bgcolor: '#060611', color: '#fff' }}
                                alt={branch.FL_BRANCH_CODE}
                                icon={<BusinessOutlinedIcon />}
                            />
                        </ListItemAvatar>
                        <ListItemText primary={`${branch.FL_BRANCH_CODE}(${branch.FL_BRANCH_CITY})`} />
                    </ListItem>
                ))}
            </List>
        </Dialog>
    </>
    );
};
// Login.Modulename = NU;

export default Login;
